import * as React from 'react'
import Typography from '~/components/_atoms/Typography/index'
import Modal from '~/components/_layouts/Modal/index'
import { apiGet } from '~/util/api'
import RichTextEditor from '~/lib/ui/rich-text-editor'
import Quill from 'quill'

export const IgnoreTaskModal = ({
  url,
  modalOpen,
  setModalOpen,
  serviceRequestId,
}) => {
  const handleIgnoreFollowUp = async () => {
    try {
      const res = await apiGet(
        `/coach/send_follow_up?service_request_id=${serviceRequestId}&ignore_follow_up=true`,
      )
      if (res.status === 200) {
        window.location.href = url
      }
    } catch (error) {
      console.error('Error sending follow-up message:', error)
    }
  }
  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      title="Handle Follow-Up"
      size="sm"
      actions={[
        <button
          key="cancel"
          className="btn btn-ghost"
          onClick={() => setModalOpen(false)}
        >
          Cancel
        </button>,
        <button
          key="confirm"
          className="btn btn-primary"
          onClick={handleIgnoreFollowUp}
        >
          Confirm
        </button>,
      ]}
    >
      <Typography>
        {`You are ignoring this task because you know this candidate does not need follow-up. To keep good records, ensure you make a note for this candidate.`}
      </Typography>
    </Modal>
  )
}

export const FollowUpModal = ({
  modalOpen,
  setModalOpen,
  onSuccess,
  serviceRequest,
  candidateFirstName,
  coachFirstName,
}) => {
  const editorRef = React.useRef(null)

  let displayName = serviceRequest.service_request || serviceRequest.displayName

  // Parse defaultEmailMessage to HTML for RichTextEditor
  let defaultEmailMessage
  if (displayName == 'Resume Review' || displayName == 'Resume Development') {
    defaultEmailMessage = {
      ops: [
        {
          insert: `Hi ${candidateFirstName},\n\nI'm ready for the next step in your resume review.\n\nPlease schedule your next revision meeting or submit your resume for an online review within the next 14 days. I'll personally review your resume and provide feedback either way.\n\nIf you don't take the next step within 14 days, I'll need to close your current resume review. Once it's closed, it cannot be reopened, so please be sure to continue if you'd like to complete your review.\n\nTo continue, click below:\n\n{get_review_button}`,
        },
        {
          insert: '\n\nI hope to work with you again soon!',
        },
        {
          insert: `\n\nBest,\nCoach ${coachFirstName}\n`,
        },
      ],
    }
  } else {
    defaultEmailMessage = {
      ops: [
        {
          insert: `Hi ${candidateFirstName},\n\nI hope this message finds you well. I just wanted to check in to see how things are progressing with your ${displayName}. If you need any further assistance or would like to schedule another session, please don't hesitate to reach out.\n\n{service_request_button}`,
        },
        {
          insert: '\n\nI look forward to hearing from you soon!',
        },
        {
          insert: `\n\nBest,\nCoach ${coachFirstName}\n`,
        },
      ],
    }
  }

  // Convert Quill Delta to HTML (assuming RichTextEditor uses Quill)
  const quillTemp = document.createElement('div')
  const quillInstance = new Quill(quillTemp)
  quillInstance.setContents(defaultEmailMessage)
  const serviceRequestId =
    serviceRequest.service_request_id || serviceRequest.id

  const sendFollowUpMessage = async () => {
    try {
      const res = await apiGet(
        `/coach/send_follow_up?service_request_id=${serviceRequestId}&follow_up_message=${encodeURIComponent(editorRef?.current?.getSemanticHTML())}`,
      )
      if (res.status === 200) {
        onSuccess()
      }
    } catch (error) {
      console.error('Error sending follow-up message:', error)
    }
  }
  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      title="Send Follow-Up Message"
      size="md"
      actions={[
        <button
          key="cancel"
          className="btn btn-ghost"
          onClick={() => setModalOpen(false)}
        >
          Cancel
        </button>,
        <button
          key="confirm"
          className="btn btn-primary"
          onClick={sendFollowUpMessage}
        >
          Send Follow-up
        </button>,
      ]}
    >
      <Typography variant="subtitle">
        {`It's been 3 weeks since this candidate engaged with the ${displayName}
        process. Unless you know what's going on, it's a good time to send them
        a follow-up message.`}
      </Typography>
      <div>
        <RichTextEditor
          className="h-[425px]"
          ref={editorRef}
          defaultValue={defaultEmailMessage}
        />
      </div>
    </Modal>
  )
}
